import type { FC } from "react";

import { useTrustPilotConfig } from "@ui/hooks/useTrustPilotConfig";
import classNames from "classnames";

type TrustPilotStarsProps = {
  className?: string;
  sku: string;
  height?: string;
  width?: string;
  starColor?: string;
  reviewNumber?: string;
  scrollToList?: string;
  styleAlignment?: string;
};

export const TrustPilotStars: FC<TrustPilotStarsProps> = ({
  className,
  sku,
  height = "24px",
  width = "280px",
  starColor = "#000000",
  reviewNumber = "5",
  scrollToList = "true",
  styleAlignment = "center",
}) => {
  const { ref, isEnabled, localeCode, businessUnitId, templateId, leaveAReviewLink, theme } = useTrustPilotConfig(
    "starsWidgetTemplateId",
    { width, height }
  );

  if (!isEnabled) {
    return null;
  }

  return (
    <div
      ref={ref}
      data-testid="trustpilot-stars"
      className={classNames("trustpilot-widget", className)}
      data-sku={sku}
      data-template-id={templateId}
      data-locale={localeCode}
      data-businessunit-id={businessUnitId}
      data-style-height={height}
      data-style-width={width}
      data-theme={theme}
      data-no-reviews="show"
      data-star-color={starColor}
      data-reviewnumber={reviewNumber}
      data-scroll-to-list={scrollToList}
      data-style-alignment={styleAlignment}
    >
      <a href={leaveAReviewLink} target="_blank" rel="noopener noreferrer">
        Trustpilot
      </a>
    </div>
  );
};
